// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "Tls Lead Management",
    appLogoImage: require("@src/assets/images/logo/365-BizTool-Dark-Logo.png")
      .default,
    appLogoImageCollapsed: require("@src/assets/images/logo/365-BizTool-Favicon-Dark- Logo.png")
      .default,
    appLogoImageDark: require("@src/assets/images/logo/365-BizTool-Light-Logo.png")
      .default,
    appLogoImageCollapsedDark: require("@src/assets/images/logo/365-BizTool-Favicon-Light-Logo.png")
      .default,
    companyBrandLogo: require("@src/assets/images/logo/TrueLineLogo.png")
      .default,
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right", // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  },
};

export default themeConfig;
